import styled from "styled-components";
import {
  StyledCreateNewValues,
  StyledParseValues,
  StyledRemoveButton,
} from "../../../../../../components/CaptionBlock/styles";
import { AddIntervalButton } from "./fields/DateEditor/style";
import { Colors } from "@smartsuite/types";

export const StyledContainer = styled.p`
  .ProseMirror {
    font-size: 15px;

    .pill-node-view-wrapper {
      display: inline-flex;

      max-width: 100%;
      margin-right: 6px;
      vertical-align: bottom;
    }
  }

  .pill-picker-error {
    border-color: ${Colors.bRed};
  }
`;

export const StyledReactInputFieldContainer = styled.div`
  position: relative;
  margin-bottom: 18px;

  &:hover {
    ${StyledRemoveButton} {
      opacity: 0.4;
      width: 30px;

      &:hover {
        opacity: 1;
      }
    }

    ${StyledParseValues} {
      width: 30px;
      opacity: 1;

      &:hover {
        opacity: 1;
      }
    }

    ${StyledCreateNewValues} {
      width: 30px;
      opacity: 1;

      &:hover {
        opacity: 1;
      }
    }

    ${AddIntervalButton} {
      &.with-trash {
        right: 25px;
      }
    }
  }

  .pill-picker-editor__plus-button {
    top: 9px;
    right: 9px;

    display: inline-flex;
  }

  .pill-picker-error {
    border-color: ${Colors.bRed};
  }

  // SMS Field
  #sms-message-editor-wrapper {
    .ProseMirror {
      min-height: 64px;
    }
  }
`;
